/**
 * POS-I313 — the Record column of a stock-adjustment audit row is built on the server
 * from the MovementType enum. The API now also sends entityName and movementType, and
 * the client translates the type through the inventory namespace (en/ur/ro).
 */
import type { TFunction } from 'i18next';

const MOVEMENT_TYPE_KEY: Record<string, string> = {
  SALE: 'sale',
  SALE_VOID: 'saleVoid',
  PURCHASE: 'purchase',
  ADJUSTMENT_IN: 'adjustmentInType',
  ADJUSTMENT_OUT: 'adjustmentOutType',
  RETURN: 'saleReturn',
  TRANSFER: 'transfer',
  DAMAGE: 'damage',
};

export interface AuditLabelSource {
  entityLabel?: string | null;
  entityName?: string | null;
  movementType?: string | null;
}

/** `tInventory` is `useTranslation('inventory').t`. Falls back to the server label. */
export function auditEntityLabel(log: AuditLabelSource, tInventory: TFunction): string | null {
  const key = log.movementType ? MOVEMENT_TYPE_KEY[log.movementType] : undefined;
  if (!key) return log.entityLabel ?? null;
  const type = tInventory(key, { defaultValue: '' }) as string;
  if (!type) return log.entityLabel ?? null;
  return log.entityName ? `${log.entityName} - ${type}` : type;
}
